import { render } from "./ElearningDashboardPage.vue?vue&type=template&id=7f2d5156"
import script from "./ElearningDashboardPage.vue?vue&type=script&lang=js"
export * from "./ElearningDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__